import { FC } from 'react';

import styles from './fireworks.module.css';

interface IFireworkProps {
  left: string;
  top: string;
  scale: number;
  delay?: string;
}

const Firework: FC<IFireworkProps> = ({ left, top, scale, delay = '0s' }) => {
  const explosions = Array.from({ length: 12 });

  return (
    <div className="absolute" style={{ left, top, transform: `scale(${scale})` }}>
      {explosions.map((_, i) => (
        <div
          key={i}
          className="absolute bottom-0 left-[-2px] h-20 w-[4px] origin-bottom overflow-hidden"
          style={{
            transform: `rotate(${i * 30}deg) translateY(-15px)`,
          }}
        >
          <span
            className="absolute left-0 right-0 top-full h-10 bg-yellow"
            style={{
              animation: `${styles.explosion} 2s ${delay} ease-in-out infinite`,
            }}
          />
        </div>
      ))}
    </div>
  );
};

export const Fireworks: FC = () => {
  return (
    <div
      className="absolute inset-0 -left-4 -right-4 z-50 flex h-full items-center justify-center overflow-hidden bg-black/40 backdrop-blur-sm sm:left-0 sm:right-0 sm:rounded-2xl"
      data-testid="fireworks"
    >
      <Firework left="50%" top="50%" scale={1} />
      <Firework left="40%" top="45%" scale={0.7} delay=".6s" />
      <Firework left="60%" top="65%" scale={0.4} delay=".4s" />
    </div>
  );
};
